import React, { useState, useEffect, useImperativeHandle, useRef } from 'react';
import { cosUrl } from '../../../const/menuData.js';
import { filterTree } from '../../../utils/index';
import { getRecentMenu } from '../../../utils/api';
import { Menu, Input, Popup } from 'tdesign-react';
import './index.css';
import { isLogin,removeDuplicates } from '../../../utils/index.js';
import { useHistory } from "react-router-dom";

const { MenuItem, SubMenu } = Menu;


export default function  Sider({
  cRef,
  menuList,
  defaultNavItems,
  action,
  currentMune,
  setConfig,
  collapsed,
  setCollapsed
}) {
  useImperativeHandle(cRef, () => ({
      addRecentMenu: (curMenu) => {
        let _recentMenu = menuList.map(i => i.children).flat().filter(i => curMenu === i.action);
        setRecentMenu(removeDuplicates([..._recentMenu,...recentMenu],'action').slice(0, 4))
      },
      setCurMenu:(result) => {
        setSelected(result.action);
        setExpanded([result?.menuKey, 'recent']);
      }
    }));

  const [navItems, setNavItems] = useState(menuList);  //  筛选后的菜单显示
  const [selected, setSelected] = useState(action); //  当前选中菜单
  const [expanded, setExpanded] = useState([currentMune?.menuKey, 'recent']);
  const [recentMenu, setRecentMenu] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchval, setSearchval] = useState('');
  const history = useHistory()

  const getRecentMenuList = async (menu) => {
    try{
      const res = await getRecentMenu();
      if(!res.error){
        let menuList = menu.map(i => i.children).flat()
        let _recentMenu = res.Data.map(menu => {
          let _curMenu = menuList.find(i => {
            return i.action === menu
          })
          if(_curMenu){
            return _curMenu
          }else{
            return null
          }
        }).filter(i => !!i)
        setRecentMenu(_recentMenu);
      }
    }catch(e){
      console.log('getRecentMenuList error')
    }

  }


  useEffect(() => {
    console.log('menuList', menuList, !!isLogin)
    setNavItems(menuList);
    if (isLogin) {
      getRecentMenuList(menuList);
    }
  }, [menuList])

  useEffect(() => {
    console.log('selected', action)
    if (action) {
      setSelected(action)
    }
  }, [action])


  useEffect(() => {
    if (currentMune) {
      setExpanded([currentMune?.menuKey, 'recent']);
    }
  }, [currentMune])

  const searchMenu = (e) => {
    if (e) {
      let searchList = filterTree(defaultNavItems, (item) => {
        return item.title.includes(e) || item.text?.includes(e) || item.action?.includes(e)
      });
      setNavItems(searchList);
    } else {
      setNavItems(defaultNavItems);
    }
  }
  return (
    <>
      <div className="ocrDemo-sider-container is-flex" style={{ width: !collapsed ? '222px' : '52px' }}>
        <div className={`ocrDemo-recent-container ${collapsed ? 'collapsed' : ''}`} style={{ width: !collapsed ? '222px' : '52px' }}>
          <div className="ocrDemo-recent-container__header">
            {
              showSearch && !collapsed ? <>
                <Input
                  value={searchval}
                  onBlur={() => setShowSearch(false)}
                  placeholder="请描述所识别场景"
                  onChange={(e) => { setSearchval(e) }}
                  onEnter={() => searchMenu(searchval)}
                  suffixIcon={<span className="ocrDemo-icon_search" onClick={() => searchMenu(searchval)}></span>}
                />
              </> : <>
                <Popup disabled={!collapsed} content={
                  <ul className="ocrDemo-menu-popContainer">
                    {
                      recentMenu.map(item => (
                        <li className={`${selected === item.action ? 'isActive' : ''} ocrDemo-menu-popContainer__item`} value={item.action}
                          onClick={(value) => {
                            setConfig(item);
                            setSelected(item.action);
                          }}
                        ><span className="t-menu__content">{item.title}</span></li>
                      ))
                    }
                  </ul>
                } placement="right" destroyOnClose>
                  <span className="ocrDemo-icon__recent" />
                </Popup>
                {
                  !collapsed && <>
                    <span>最近访问</span>
                    <span className="ocrDemo-icon__recent-search" onClick={() => setShowSearch(true)}></span>
                  </>
                }

              </>
            }
          </div>
          {
            !collapsed && recentMenu?.length > 0 && <div className="ocrDemo-recent-menuItem_container">
              {
                recentMenu?.map(menuItem => (
                  <div
                    className={`ocrDemo-recent-menuItem ${selected === menuItem.action ? 'isOpen' : ''}`}
                    onClick={() => {
                      setConfig(menuItem);
                      setSelected(menuItem.action);
                      history.push({search: `action=${menuItem.action}`})
                    }}>{menuItem.title}</div>
                ))
              }
            </div>
          }
        </div>

        <div className="menu_container">
          {/* <MenuItem>文档处理</MenuItem> */}
          <Menu
            style={{ width: !collapsed ? '222px' : '52px' }}
            value={selected}
            expanded={expanded}
            onExpand={(value) => {
              setExpanded(value)
            }}
            collapsed={collapsed}
            expandMutex
            operations={
              <div className="ocrDemo-sider-container__menuBtn" >
                <span className="btn-click_container" >
                  <span onClick={() => {
                    setCollapsed(!collapsed)
                  }} className="ocrDemo-sider-container__menuBtn_icon"></span>
                  {
                    !collapsed && <span onClick={() => {
                      setCollapsed(!collapsed)
                    }}>收起</span>
                  }
                </span>
              </div>
            }
          >
            {navItems && navItems.map(menu => (
              <SubMenu value={menu?.key} title={menu.title} icon={
                <img className="ocrDemo-sider-menu__icon" src={cosUrl + menu.icon} />
              }>
                {
                  menu.children.map(item => (
                    <MenuItem value={item.action}
                      onClick={(value) => {
                        setConfig(item);
                        setSelected(item.action);
                        history.push({ search: `action=${item.action}` })

                      }}
                    >{item.title}</MenuItem>
                  ))
                }
              </SubMenu>
            ))}
          </Menu>
        </div>
      </div>
    </>
  );
};